import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';

import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { MutationStateFns } from '@/api/utils/mutation';
import { useAuth } from '@/context/AuthProvider';

const METHOD = 'POST';
const ENDPOINT = 'document';

export type ApiResponse_AssignDocumentToFolder = {
  success: boolean;
  message: string;
};

export const useAssignDocumentToFolder = (
  stateFns?: MutationStateFns<ApiResponse_AssignDocumentToFolder>
) => {
  const { session } = useAuth();

  return useMutation({
    mutationFn: async (documentId: string) =>
      handleApiCall<ApiResponse_AssignDocumentToFolder>(
        session,
        METHOD,
        getResolvedEndpoint(`${ENDPOINT}/${documentId}/assign-folder`, {})
      ),
    onSuccess: data => {
      enqueueSnackbar('Document assigned to folder successfully', { variant: 'success' });
      stateFns?.onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      enqueueSnackbar('Failed to assign document to folder.', { variant: 'error' });
      stateFns?.onError?.(err);
    },
  });
};
